export default {
  lang: { zh: '中文', en: 'English', th: 'ไทย' },
  common: {
    back: 'กลับ',
    scan: 'สแกน',
    paste: 'วาง',
    clear: 'ล้าง',
    clearAll: 'ล้างทั้งหมด',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    next: 'ถัดไป',
    startImport: 'เริ่มนำเข้า',
    upgradeNow: 'อัปเกรดเลย',
    input: 'ป้อน',
    logo: 'โลโก้'
  },
  errors: {
    invalidWords: '{words} ไม่ใช่คำช่วยจำที่ถูกต้อง กรุณาตรวจสอบ',
    need12Words: 'กรุณาป้อน 12 คำช่วยจำที่ถูกต้อง',
    incompleteWords: 'ตรวจพบเพียง {count} คำ ใช้ 12/15/18/21/24 คำ กดเว้นวรรค/Enter หลังคำสุดท้ายในการป้อนแบบชิป',
    invalidLength: 'คำช่วยจำต้องมี 12/15/18/21/24 คำ ปัจจุบัน {count} คำ',
    mnemonicIncorrect: 'คำช่วยจำไม่ถูกต้อง กรุณาตรวจสอบ',
    checksumInvalid: 'Checksum ไม่ถูกต้อง: คำอยู่ในรายการแต่คำผิด ตรวจสอบลำดับ/การสะกด ใช้เว้นวรรคไม่ใช่เครื่องหมายจุลภาค',
    checksumInvalidDetail: 'Checksum ไม่ถูกต้อง ({count} คำ): ตรวจสอบลำดับและการสะกด ใช้เว้นวรรค ใช้วางเพื่อป้อนใหม่ คำที่ไม่ใช่ BIP39 อาจล้มเหลว',
    validateFailed: 'การตรวจสอบคำช่วยจำล้มเหลว: {error}',
    validateFailedSimple: 'การตรวจสอบคำช่วยจำล้มเหลว กรุณาตรวจสอบและลองอีกครั้ง',
    saveFailed: 'บันทึกคำช่วยจำล้มเหลว ตรวจสอบการลงทะเบียนอุปกรณ์และเครือข่าย',
    saveFailedDetail: 'บันทึกคำช่วยจำล้มเหลว: {error}',
    missingDeviceId: 'ไม่พบ ID อุปกรณ์ ส่งการแจ้งเตือนใหม่จากผู้ดูแลหรืออัปเดต APK',
    networkFailed: 'คำขอเครือข่ายล้มเหลว อย่าใช้ 127.0.0.1 จากโทรศัพท์/WebView',
    unknownError: 'ข้อผิดพลาดที่ไม่ทราบสาเหตุ'
  },
  upgrade: {
    title: 'แจ้งเตือนการอัปเกรด',
    packageInfo: 'ขนาดแพ็กเกจ: {size} MB · การอัปเดต:',
    im: {
      f1: '1. ปรับปรุงแอนิเมชันแบนเนอร์ข้อผิดพลาดและเวลาการแสดง',
      f2: '2. เพิ่มความแม่นยำและประสิทธิภาพการตรวจสอบพื้นฐาน',
      f3: '3. ปรับปรุงตรรกะการวางและจัดรูปแบบการป้อน',
      f4: '4. แก้ไขปัญหาความเสถียรที่ทราบแล้วหลายรายการ'
    },
    tp: {
      f1: '1. ปรับปรุงการรีเฟรชตลาดและประสิทธิภาพแผนภูมิ',
      f2: '2. เพิ่มความเสถียรการเชื่อมต่อ Bluetooth',
      f3: '3. แก้ไขปัญหาความเสถียรและความล่าช้าที่ทราบแล้วหลายรายการ',
      f4: '4. เพิ่มประสบการณ์ผู้ใช้โดยรวม'
    },
    tronlink: {
      f1: '1. เพิ่มความเสถียรการเชื่อมต่อ/เชื่อมต่อใหม่ DApp',
      f2: '2. ปรับปรุงการโหลดรายการธุรกรรมและการโต้ตอบการกรอง',
      f3: '3. เพิ่มการเร่งด้วยฮาร์ดแวร์และความลื่นไหลของแอนิเมชัน',
      f4: '4. แก้ไขปัญหาโฟกัสการป้อนบนอุปกรณ์บางรุ่น'
    }
  },
  importMnemonic: {
    title: 'นำเข้าคำช่วยจำ',
    description:
      'ป้อนคำช่วยจำเพื่อเพิ่มหรือกู้คืนกระเป๋าเงิน คำช่วยจำที่นำเข้าจะถูกเข้ารหัสและเก็บอย่างปลอดภัยบนอุปกรณ์ของคุณ เพื่อความปลอดภัยของสินทรัพย์ imToken จะไม่เก็บคำช่วยจำของคุณ',
    startImport: 'เริ่มนำเข้า'
  },
  mnemonicInput: {
    title: 'นำเข้าคำช่วยจำ',
    description:
      'ป้อนคำช่วยจำเพื่อเพิ่มหรือกู้คืนกระเป๋าเงิน คำช่วยจำที่นำเข้าจะถูกเข้ารหัสและเก็บอย่างปลอดภัยบนอุปกรณ์ของคุณ เพื่อความปลอดภัยของสินทรัพย์ imToken จะไม่เก็บคำช่วยจำของคุณ',
    learnLink: 'เรียนรู้เกี่ยวกับคำช่วยจำ',
    placeholder: 'ป้อนคำช่วยจำ คั่นด้วยเว้นวรรค',
    importNow: 'นำเข้าทันที',
    modalTitle: 'คำช่วยจำคืออะไร?',
    modalP1:
      'คำช่วยจำคือชุดคำภาษาอังกฤษ 12–24 คำที่จดจำง่าย ใช้แทนคีย์เข้ารหัสที่ยาวและซับซ้อนกว่า คุณสามารถใช้คำช่วยจำเพื่อสำรองและกู้คืนกระเป๋าเงิน',
    modalP2: 'ใครก็ตามที่มีคำช่วยจำเหล่านี้สามารถควบคุมสินทรัพย์ในกระเป๋าเงินได้ โปรดจำไว้ว่า:',
    modalL1: 'เก็บคำช่วยจำให้ปลอดภัยตลอดเวลา',
    modalL2: 'อย่าแชร์คำช่วยจำกับใคร',
    modalL3: 'อย่าใช้คำช่วยจำจากแหล่งที่ไม่รู้จัก',
    modalL4: 'แนะนำให้ใช้อุปกรณ์ฮาร์ดแวร์ imKey สำหรับการสำรอง',
    learnMore: 'เรียนรู้เพิ่มเติม'
  },
  tpImport: {
    title: 'นำเข้ากระเป๋า TP',
    description: 'เตรียมคำช่วยจำหรือคีย์ส่วนตัวของกระเป๋าเงิน หลังนำเข้าแล้วสามารถใช้งานได้ทันที'
  },
  tpWallet: {
    title: 'นำเข้ากระเป๋าเงิน',
    tabMnemonic: 'คำช่วยจำ',
    tabPrivateKey: 'คีย์ส่วนตัว',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'ป้อนคำช่วยจำตามลำดับ คั่นด้วยเว้นวรรค',
    placeholderPrivateKey: 'ป้อนคีย์ส่วนตัว',
    placeholderKeystore: 'ป้อนเนื้อหา Keystore',
    keypalCard: 'KeyPal Card',
    chainName: 'ชื่อเชน',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'โหมดขั้นสูง >',
    agreementPrefix: 'ฉันได้อ่านและยอมรับ',
    serviceAgreement: 'ข้อตกลงการให้บริการ',
    confirmImport: 'ยืนยันการนำเข้า'
  },
  tronlinkImport: {
    title: 'นำเข้ากระเป๋าเงิน',
    description:
      'ป้อนคำช่วยจำ คีย์ส่วนตัว หรือเนื้อหาไฟล์ Keystore เพื่อกู้คืนหรือย้ายกระเป๋าเงิน เราไม่เก็บข้อมูลคีย์ส่วนตัวของคุณ'
  },
  tronlinkWallet: {
    title: 'นำเข้ากระเป๋าเงิน',
    placeholder: 'ป้อนคำช่วยจำหรือคีย์ส่วนตัว'
  },
  metamask: {
    importTitle: 'นำเข้ากระเป๋าเงิน',
    subTitle: 'ป้อนคำกู้คืนที่นี่',
    placeholder: 'คั่นแต่ละคำด้วยเว้นวรรคและตรวจสอบว่าไม่มีใครมองดู',
    wordHint: 'ใช้ตัวพิมพ์เล็กเท่านั้น ตรวจสอบการสะกด และรักษาลำดับคำเดิม',
    continue: 'ดำเนินการต่อ',
    sheetTitle: 'คำกู้คืนที่ลับคืออะไร?',
    sheetP1:
      'คำกู้คืนที่ลับ (เรียกว่าคำช่วยจำ) คือชุดคำที่ให้คุณเข้าถึงและควบคุมกระเป๋าเงินคริปโต คุณต้องใช้เพื่อย้ายกระเป๋าเงินไป MetaMask',
    sheetListTitle: 'ใครก็ตามที่มีคำกู้คืนที่ลับของคุณสามารถ:',
    sheetL1: 'เอาเงินทั้งหมดของคุณ',
    sheetL2: 'ยืนยันธุรกรรม',
    sheetL3: 'เปลี่ยนข้อมูลการเข้าสู่ระบบ',
    gotIt: 'เข้าใจแล้ว'
  },
  trust: {
    headerTitle: 'กระเป๋าเงินหลายเหรียญ',
    walletName: 'ชื่อกระเป๋าเงิน',
    defaultWalletName: 'กระเป๋าเงินหลัก 1',
    mnemonicLabel: 'คำกู้คืน',
    tips: 'โดยปกติ 12 คำ (บางครั้ง 18 หรือ 24) คั่นด้วยเว้นวรรคเดียว',
    invalidMnemonic: 'คำกู้คืนไม่ถูกต้อง'
  },
  okx: {
    title: 'ป้อนคำกู้คืนหรือคีย์ส่วนตัว',
    placeholder: 'หากนำเข้าด้วยคำกู้คืน คั่นแต่ละคำด้วยเว้นวรรค'
  }
};
